const Alert = ({ children, style = {}, ...props }) => (
  <div
    role="alert"
    style={{
      position: "relative",
      width: "100%",
      borderRadius: "8px",
      border: "1px solid #ddd",
      padding: "16px",
      ...style,
    }}
    {...props}
  >
    {children}
  </div>
);

const AlertTitle = ({ children, style = {}, ...props }) => (
  <h5
    style={{
      marginBottom: "4px",
      fontWeight: "500",
      lineHeight: "1.2",
      ...style,
    }}
    {...props}
  >
    {children}
  </h5>
);

const AlertDescription = ({ children, style = {}, ...props }) => (
  <div
    style={{
      fontSize: "14px",
      ...style,
    }}
    {...props}
  >
    {children}
  </div>
);

export { Alert, AlertTitle, AlertDescription };
